import { logisticsEvent, profileTypeEndPoint, profileTypeEnum, tableMapData } from "@components/templates/Profile/ProfileHeader/profile-enum";
import ProfileTable from "@components/templates/Profile/ProfileTable";
import { globalCountryDetailsDictionary } from "@core/global/global-country-details";
import { generateTrackingObject } from "@core/global/global-country-functions";
import { trademoTrackingEvents } from "@core/global/trademo-tracking";
import { getEventName, getUserActivePlan } from "@helpers/profileHelper";
import { logisticsCachingHandler } from "@redux/LogisticsProfile/logisticsProfileSlice";
import axios from "axios";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
const LogisticsTable = ({ tableName }) => {
  const [isLoaderActive, setIsLoaderActive] = useState(true);
  const [tradingPartnerData, setTradingPartnerData] = useState([]);
  const [tradingPartnerCount, setTradingPartnerCount] = useState(null);
  const [tradingPartnerMustNotInclude, setTradingPartnerMustNotInclude] = useState([]);
  const [sortOrderValue, setSortOrderValue] = useState("desc");
  const [selectedTradingPartner, setSelectedTradingPartner] = useState([]);
  const [clearSelectedTradingPartner, setClearSelectedTradingPartner] = useState(false);
  const [tradingPartnerCurrentPage, setTradingPartnerCurrentPage] = useState(1);
  const [tradingPartnerRange, setTradingPartnerRange] = useState({ from: 1, to: 100 });
  const { companyId, companyName } = useParams();
  const { tabDetails, profileRedirectionId, logisticsCaching } = useSelector((state) => state.logisticsProfile);
  const { activeTabId, activePanelId } = tabDetails;
  const { search: searchUrlParams, pathname } = useLocation();
  const dataSource = new URLSearchParams(searchUrlParams).get("dataSource");
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.userDetails.userData);
  const globalPlanCheck = userData?.planIds?.find((planId) => planId?.navigate === "search" && planId?.productId === globalCountryDetailsDictionary?.global_plan?.product_id);

  const downloadEvent = () => {
    trademoTrackingEvents(getEventName(profileTypeEnum.logistics, logisticsEvent[activeTabId]?.tabDownload), generateTrackingObject(dataSource, pathname, getUserActivePlan()));
  };

  const viewShipmentsEvent = () => {
    trademoTrackingEvents(getEventName(profileTypeEnum.logistics, logisticsEvent[activeTabId]?.viewShipments), generateTrackingObject(dataSource, pathname, getUserActivePlan()));
  };

  const companyRedirectionEvent = () => {
    trademoTrackingEvents(getEventName(profileTypeEnum.logistics, logisticsEvent[activeTabId]?.profileClick), generateTrackingObject(dataSource, pathname, getUserActivePlan()));
  };

  useEffect(() => {
    setSelectedTradingPartner([]);
  }, [activePanelId, activeTabId]);
  const callTrendingPartners = (tradingPartnerData = [], tradingPartnerMustNotInclude = [], sortOrderValue = "desc", isPaginate) => {
    const requestPayload = {
      profile_type: profileTypeEnum.logistics,
      _id: companyId,
      category: activePanelId,
      sub_category: activeTabId,
      map_type: "",
      order: sortOrderValue,
      must_not: tradingPartnerMustNotInclude,
    };
    setIsLoaderActive(true);
    setClearSelectedTradingPartner(false);
    setTradingPartnerCurrentPage(1);
    if (logisticsCaching[activeTabId] && logisticsCaching?.[activeTabId]?.sortOrderValue === sortOrderValue && !isPaginate) {
      let logisticsCachingClone = JSON.parse(JSON.stringify(logisticsCaching));
      const { tableData, tableCount, sortOrderValue, mergedMustNotIncludeTradingPartner } = logisticsCachingClone[activeTabId];
      setTradingPartnerData(tableData);
      setTradingPartnerCount(tableCount);
      setTradingPartnerMustNotInclude(mergedMustNotIncludeTradingPartner);
      setSortOrderValue(sortOrderValue);
      setIsLoaderActive(false);
    } else {
      axios
        .post(profileTypeEndPoint.ports.getShipperDetails, requestPayload)
        .then((res) => {
          const { data, status } = res.data;
          if (!!status && status.toLocaleUpperCase() === "success".toLocaleUpperCase()) {
            const tableData = data[tableMapData[activeTabId].data];
            const tableCount = data[tableMapData[activeTabId].count];
            const mustNot = data.must_not;
            if (!!data && !!tableData && tableData.length !== 0) {
              let mergedMustNotIncludeTradingPartner = tradingPartnerMustNotInclude.concat(mustNot);
              let mergedTradingPartnerData = tradingPartnerData.concat(tableData);
              if (tableCount !== undefined && tableCount < 100) {
                setTradingPartnerRange({ from: 1, to: tableCount });
              }
              setTradingPartnerData(mergedTradingPartnerData);
              setTradingPartnerCount(tableCount);
              setTradingPartnerMustNotInclude(mergedMustNotIncludeTradingPartner);
              setSortOrderValue(sortOrderValue);
              let logisticsCachingClone = JSON.parse(JSON.stringify(logisticsCaching));
              logisticsCachingClone[activeTabId] = { tableData: mergedTradingPartnerData, tableCount: tableCount, sortOrderValue: sortOrderValue, mergedMustNotIncludeTradingPartner: mergedMustNotIncludeTradingPartner };
              dispatch(logisticsCachingHandler(logisticsCachingClone));
            } else {
              setTradingPartnerData([]);
              setTradingPartnerCount(0);
              setTradingPartnerMustNotInclude([]);
              setSortOrderValue("desc");
            }
            setIsLoaderActive(false);
          } else {
            toast.error("Something went wrong. Please try again after sometime !!!");
          }
        })
        .catch(() => {
          setIsLoaderActive(false);
          toast.error("Something went wrong. Please try again later !!!");
        });
    }
  };

  return (
    <ProfileTable
      tableName={tableName}
      callTrendingPartners={callTrendingPartners}
      isLoaderActive={isLoaderActive}
      tradingPartnerData={tradingPartnerData}
      tradingPartnerCount={tradingPartnerCount}
      sortOrderValue={sortOrderValue}
      tradingPartnerMustNotInclude={tradingPartnerMustNotInclude}
      tradingPartnerRange={tradingPartnerRange}
      setTradingPartnerRange={setTradingPartnerRange}
      category={activePanelId}
      subCategory={activeTabId}
      profileName={companyName}
      profileType={profileTypeEnum.logistics}
      profileId={companyId}
      selectedTradingPartner={selectedTradingPartner}
      setSelectedTradingPartner={setSelectedTradingPartner}
      clearSelectedTradingPartner={clearSelectedTradingPartner}
      setClearSelectedTradingPartner={setClearSelectedTradingPartner}
      tradingPartnerCurrentPage={tradingPartnerCurrentPage}
      setTradingPartnerCurrentPage={setTradingPartnerCurrentPage}
      downloadEvent={downloadEvent}
      dataSource={dataSource}
      viewShipmentsEvent={viewShipmentsEvent}
      companyRedirectionEvent={companyRedirectionEvent}
      profileRedirectionId={profileRedirectionId}
      globalPlan={globalPlanCheck?.navigate === "search" ? true : false}
    />
  );
};

export default LogisticsTable;
